import { StarterController } from './StarterController';
import { StarterWidgetPropertyController } from './StarterWidgetPropertyController';
import AngularHelper from '../../../src/angular/AngularHelper';

angular.module('app.newstarter', [])
.config(AngularHelper.config())
.run(AngularHelper.run());

logpresso.controller('StarterController', StarterController);
logpresso.controller('StarterWidgetPropertyController', StarterWidgetPropertyController);


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/starter/app.entry.js